import React from 'react';
import DBCActions from './DBCActions';
import JobButtons from '../../../Meetings/JobButtons';
import Security from '../../../../utils/Security';

const BUTTON_SIZE = 'tiny';

const JobActions = ({ job }) => {
  const isDecibio = Security.isDecibio();
  const isSuperUser = Security.isSuperUser();

  return (
    <div className="actions">
      {(isDecibio || isSuperUser) && <DBCActions job={job} />}
      <JobButtons job={job} size={BUTTON_SIZE} display="horizontal" />
    </div>
  );
};

export default JobActions;
